import {Directive, ElementRef, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: 'img',
  standalone: false
})
export class ImageBaseAttributeDirective implements OnInit {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {
    const loading = this.elementRef.nativeElement.getAttribute('loading');
    if (!loading) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'loading', 'lazy');
    }
    const alt = this.elementRef.nativeElement.getAttribute('alt');
    if (!alt) {
      const src = this.elementRef.nativeElement.getAttribute('src');
      this.renderer.setAttribute(this.elementRef.nativeElement, 'alt', src.split('.')[0].replaceAll('/', ' ').replace('icons', '').trim());
    }
  }
}
